export enum LegalDocStatus {
  ACCEPTANCE_NOT_REQUIRED = 'AcceptanceNotRequired',
  NOT_ACCEPTED = 'NotAccepted',
  ACCEPTED = 'Accepted',
  UPDATE_NOT_ACCEPTED = 'UpdateNotAccepted',
}
